import { render } from "./Payment.vue?vue&type=template&id=e0833824"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/Payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0833824"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0833824', __exports__)) {
    api.reload('e0833824', __exports__)
  }
  
  module.hot.accept("./Payment.vue?vue&type=template&id=e0833824", () => {
    api.rerender('e0833824', render)
  })

}


export default __exports__